<template>
  <div class="field my-margin-bottom">
    <label class="label">{{name}}</label>
    <div class="control">
      <div class="select is-fullwidth">
        <select v-bind:value="value" v-on:change="onChange" v-bind:id="id">
          <option v-for="(opt) in options" :key="opt.id">{{ opt.name }}</option>
        </select>
      </div>
    </div>
    <p class="help">
      <span v-html="units"></span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    units: String,
    name: String,
    options: Array,
    id: String,
  },
  methods: {
    onChange(event) {
      this.$emit('selected', event.target.value);
    },
  },
};
</script>

<style scoped>
div.my-margin-bottom {
  /* The select field has no help text below. Setting extra
   * margin-bottom to align vertically with normal fields. */
  margin-bottom: 2.15em;
}
</style>
